import { useContext, useEffect, useMemo, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { OpenerContext } from '@/components/C1Opener/OpenerCommunicator';
import { useIsC1Integrated } from '@/components/C1Integration/useIsC1Integrated';

export default function useUserId() {
    const [userId, setUserId] = useState<string | undefined>();
    const opener = useContext(OpenerContext);
    const isC1Integrated = useIsC1Integrated();

    useEffect(() => {
        if(userId) {
            return; // User ID already set
        }
        if (!isC1Integrated) {
            fetchAuthSession().then(auth => {
                const cognitoUserId = auth.userSub;
                setUserId(cognitoUserId);
            });
        } else if (opener?.initData) {
            const expectedUserId = opener.initData.userId;
            setUserId(expectedUserId);
        }
    }, [opener, isC1Integrated, setUserId, userId]);

    return useMemo(() => userId, [userId]);
}